import { render, staticRenderFns } from "./agregarTelefonoButton.vue?vue&type=template&id=50fe79ce"
import script from "./agregarTelefonoButton.vue?vue&type=script&lang=js"
export * from "./agregarTelefonoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports